module.exports = __webpack_public_path__ + "img/logo.32d9672b.jpg";